// DCON-3903 — "Nudge Prospects on Non-brand Pgs to take the Quiz"
import { CONTENT_TYPES } from 'src/common/constants'

/** Non-brand pages enrolled in the test: articles, blog posts and GEO pages (DCON-3902). */
export const NON_BRAND_CONTENT_TYPES = [
  CONTENT_TYPES.ARTICLE_PAGES,
  CONTENT_TYPES.BLOG_PAGES,
  CONTENT_TYPES.DEBT_CONSOLIDATION_STATES_CITIES,
]

/** Session time (across pages) before the nudge is shown. */
export const PROSPECT_QUIZ_NUDGE_DELAY_MS = 45000

/** sessionStorage: set once the visitor engaged with or dismissed the nudge. */
export const PROSPECT_QUIZ_NUDGE_HANDLED_KEY = 'prospectQuizNudgeHandled'

/** sessionStorage: epoch ms of the first page view of the session. */
export const PROSPECT_QUIZ_NUDGE_SESSION_START_KEY =
  'prospectQuizNudgeSessionStart'
